import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, ListGroup, ListGroupItem } from 'reactstrap';
import CampaignTypeForm from './CampaignTypeForm';
import adminApi from '../../services/adminApi'; // Replace axios with adminApi

const CampaignTypeList = () => {
  const [campaignTypes, setCampaignTypes] = useState([]);
  const [selectedCampaignType, setSelectedCampaignType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCampaignTypes = async () => {
    setLoading(true);
    try {
      const response = await adminApi.get(
        process.env.REACT_APP_PROMOTION_API_SERVICE_BASE_URL +
          'api/v1/campaign-types'
      );
      setCampaignTypes(response.data);
    } catch (err) {
      console.error(err);
      console.error('Error details:', err);
      setError('Failed to fetch campaign types.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaignTypes();
  }, []);

  const handleEditClick = (campaignType) => {
    setSelectedCampaignType({
      _id: campaignType._id,
      name: campaignType.name,
      description: campaignType.description,
    });
    setIsModalOpen(true);
  };

  const handleCreateClick = () => {
    setSelectedCampaignType(null);
    setIsModalOpen(true);
  };

  const handleDeleteClick = async (campaignTypeId) => {
    if (window.confirm('Are you sure you want to delete this campaign type?')) {
      try {
        await adminApi.delete(
          `${process.env.REACT_APP_PROMOTION_API_SERVICE_BASE_URL}api/v1/campaign-types/${campaignTypeId}`
        );
        setCampaignTypes((prev) =>
          prev.filter((campaignType) => campaignType._id !== campaignTypeId)
        );
      } catch (err) {
        console.error('Error details:', err);
        setError('Failed to delete campaign type.');
      }
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-danger">{error}</div>;

  return (
    <div className="campaign-type-list">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div />
        <Button color="primary" onClick={handleCreateClick}>
          Create New Campaign Type
        </Button>
      </div>
      {campaignTypes.length > 0 ? (
        <ListGroup>
          {campaignTypes.map((campaignType) => (
            <ListGroupItem
              key={campaignType._id}
              className="d-flex justify-content-between align-items-center"
            >
              <span>{campaignType.name}</span>
              <div className="d-flex flex-row gap-3">
                <Button
                  size="sm"
                  color="secondary"
                  onClick={() => handleEditClick(campaignType)}
                >
                  Edit
                </Button>
                <Button
                  size="sm"
                  color="danger"
                  onClick={() => handleDeleteClick(campaignType._id)}
                >
                  Delete
                </Button>
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      ) : (
        <div className="text-muted">No campaign types available.</div>
      )}
      <CampaignTypeForm
        campaignType={selectedCampaignType}
        onSave={() => fetchCampaignTypes()}
        show={isModalOpen}
        handleClose={() => {
          setIsModalOpen(false);
        }}
      />
    </div>
  );
};

export default CampaignTypeList;
